export default "__VITE_PUBLIC_ASSET__45741eb7__"